<template>
    <div>
        <!-- Header section -->
        <header class="header-section">
            <div class="container text-right">
                <div class="page-info">
                    <h2>Новини</h2>
                    <div class="page-links">
                        <router-link to="/">Начало</router-link>
                        <span class="active">Новини</span>
                    </div>
                </div>
            </div>
        </header>
        <!-- Header section end -->
        <div class="container mt-5 service">
            <div class="row">
                <div  v-for="post in news" :key="post.key" class="col-md-6 col-sm-12 col-lg-4 mb-3 mt-3 ">
                    <router-link class="link" :to="{name: 'newsDetail', params: { id: post.key }}">
                       <div class="card h-100" style="max-height: 500px;">
                           <div class="card-img-top">
                               <img class="img-fluid img-thumbnail" :src="post.image" alt="">
                           </div>
                           <div class="card-body text-muted pb-3 overflow-hidden">
                              <h5> {{ post.name | truncate(45, '...') }}</h5>
                           </div>
                           <div class="card-body text-muted pt-0 overflow-hidden" :inner-html.prop="post.description | truncate(130, '...')"></div>
                           <div class="card-body text-muted">
                               <p>{{ post.createdAt | formatDate }}</p>
                           </div>
                       </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { db } from '../../firebase';

    export default {
        data() {
            return {
                news: []
            }
        },
        created() {
            db.collection('news').orderBy('createdAt', 'desc').onSnapshot((snapshotChange) => {
                this.services = [];
                snapshotChange.forEach((doc) => {
                    this.news.push({
                        key: doc.id,
                        name: doc.data().name,
                        description: doc.data().description,
                        image: doc.data().image,
                        createdAt: doc.data().createdAt
                    })
                });
            })
        }
    }
</script>
<style>
    .link{
        text-decoration: none !important;
    }
</style>
